import FormClient from "./FormClient";

export default function NoticeFormPage() {
    return <FormClient />;
}

